import { motion } from "framer-motion";
import TextType from "../js/TextType";
import WelcomeImg from "../assests/welcomeImg.gif";
import "./Welcome.css";
import { AuthContext } from "../context/AuthContext";
import { useContext } from "react";

// Animation variants for the container and its children
const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3,
        },
    },
};

const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: { type: "spring", stiffness: 100 },
    },
};

export default function Welcome() {
    const { authData } = useContext(AuthContext);
    const isMobile = window.innerWidth < 768;

    const firstName = authData?.employee?.first_name || "";
    const lastName = authData?.employee?.last_name || "";

    return (
        <div className="welcomeContainer">
            <motion.div
                className="contentWrapper"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <motion.div variants={itemVariants}>
                    <TextType
                        text={[
                            `WELCOME ${firstName.toUpperCase()} ${lastName.toUpperCase()}`,
                        ]}
                        typingSpeed={75}
                        pauseDuration={1500}
                        showCursor={true}
                        cursorCharacter="|"
                        className="welcomeTitle"
                    />
                </motion.div>

                <motion.img
                    src={WelcomeImg}
                    alt="Welcome Animation"
                    className="welcomeImage"
                    variants={itemVariants}
                    style={{
                        width: isMobile ? "280px" : "100%",
                        maxWidth: isMobile ? "280px" : "580px",
                    }}
                />
            </motion.div>
        </div>
    );
}